import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import './students.scss';
import { Constants, ImageConstants, AccessRights } from '../../constants/constants';
import { getImageSource } from '../../utility/image-source'
import Filter from './filter/filter'
import 'bootstrap-daterangepicker/daterangepicker.css';
import Loading from '../common/loading/loading'
import SessionCache from '../routes/session-cache';
import StudentList from "./student-list/student-list"
import AssignSection from './assign-section/assign-section'
import InviteStudents from '../class/invite-students-v2/invite-students-v2';
import AddStudentComponent from '../class/add-student/add-student';
import { Modal, ModalBody } from 'reactstrap';
import StudentBulkImport from '../class/student-bulk-import/student-bulk-import';
import SetupSection from '../class/setup-section/setup-section'
import ToasterComponent from '../common/cw-toaster-component/cw-toaster-component';

class Students extends Component {

    state = {
        isLoading: true,
        meta: {},
        showList: true,
        from: "students"
    }
    filter = {}

    accessRights = SessionCache.getAllowedModule()

    constructor(props) {
        super(props)
        this.user = SessionCache.getUser()
    }

    /**
     * Get respective params from the provided URL
     * @param {*} name - Param name
     * @param {*} url - Provided URL
     */
    getParameterByName = (name, url) => {
        if (url) {
            name = name.replace(/[\[\]]/g, '\\$&')
            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                results = regex.exec(url)
            if (!results) return null
            if (!results[2]) return ''
            return decodeURIComponent(results[2].replace(/\+/g, ' '))
        }

        return ''
    }

    componentDidMount() {
        console.log(this.props?.location)
        this.selectedClass = this.getParameterByName(
            'c',
            this.props?.location?.search
        )
        this.sectionNotAssinged = this.getParameterByName(
            'unassign',
            this.props?.location?.search
        )
        if (this.selectedClass && this.sectionNotAssinged) {
            this.setState({
                showAssignSection: true,
                from: "classes"
            })
        }

        if (this.props?.location?.state?.sectionDetail?._id) {

            let payload = {}
            payload.board = this.props?.location?.state?.sectionDetail?.board
            payload.class = this.props?.location?.state?.sectionDetail?.class

            if (this.props?.location?.state?.sectionDetail?.noSectionInClass) {
                payload.type = "WITHOUT_SECTION"
                // payload.sectionId = this.props?.location?.state?.sectionDetail?._id
            } else {
                payload.sectionId = this.props?.location?.state?.sectionDetail?._id
            }

            this.onFilterGo(payload)

        } else {
            this.getStudent()
        }



    }


    // if (this.state.selectedBoard) {
    //     payload.board = this.state.selectedBoard
    // }
    // if (this.state.selectedClass) {
    //     payload.class = this.state.selectedClass
    // }
    // if (this.state.selectedSection) {
    //     payload.sectionId = this.state.selectedSection
    // }

    // getClusterRules(payload = {}) {

    //     CommonApi.getClusterRules(payload).then(response => {
    //         let data = response?.response
    //         let hash = {};
    //         for (let i = 0; i < data.length; i++) {
    //             hash[data[i].type] = data[i]
    //         }
    //         if (this.props?.location?.state?.school_name) {
    //             const schoolName = this.props?.location?.state?.school_name
    //             this.onFilterGo({ schoolName })
    //             this.filterRef.onChangeHandler({ target: { value: schoolName } }, 'schoolName')
    //         } else {
    //             this.getUserEngagementActivity();
    //         }
    //         this.setState({ engagementStatusHash: hash })
    //     }).catch(err => {
    //     })
    // }

    getStudent(payload, callback) {
        this.studentListRef.getStudent(payload, this.filter, _ => {
            this.setState({
                isLoading: false
            })
            if (callback && typeof callback === "function") callback()
        })
    }

    onFilterGo = (payload, callback) => {
        this.filter = payload || {}
        this.getStudent(this.filter, callback)
    }

    onRefreshList = (payload, callback) => {
        if (payload.forBulkDelete) {
            this.getStudent(payload, callback)
        } else {
            this.filterRef.onSelectDropDown(payload.status, "selectedStatus")
            this.filterRef.onSelectDropDown(payload.schoolApprovalStatus, "selectedSchoolApprovalStatus", _ => {
                this.filterRef.onClickGo(callback)
            })
        }
    }

    onPageSelected = (selectedPage, startIndex) => {
        this.startIndex = startIndex
        this.filter.page = selectedPage
        this.setState({ selectedPage })
        this.getStudent(this.filter)
    }

    onSaveStudent = _ => {
        this.closeAddStudentModal()
        this.getStudent(this.filter)
    }

    onClickAssign = () => {
        this.setState({ showAssignSection: true })
    }

    handleback = () => {
        this.setState({ showAssignSection: false }, _ => {
            this.getStudent(this.filter)
        })
    }

    showSetupSection = (selectedBoard, selectedClass) => {
        this.setState({ showSetupSection: true, selectedClass, selectedBoard })
    }

    hideSetupClass = (reFetch) => {
        if (reFetch) {
            if (reFetch === true) this.showToaster('info', 'Section added or updated successfully')
            if (this.addStudentRef) this.addStudentRef.getSections({})
            //if(this.studentListRef) this.studentListRef.getSectionList()
        }
        this.setState({ showSetupSection: false, selectedClass: null })
    }

    showInviteStudents = () => {
        this.setState({ showInviteStudents: true })
    }

    hideInviteStudents = (success) => {
        if (success === true) this.showToaster('info', 'Message shared successfully on Whatsapp')
        this.setState({ showInviteStudents: false })
        if (this.tooltip) {
            this.tooltip.tooltipRef = null
            this.tooltip.hideTooltip()
        }
        ReactTooltip.hide()
    }

    onClickAddStudent(item, mode) {
        this.setState({ openAddStudent: true, selectedUser: item, mode })
    }

    closeAddStudentModal = () => {
        this.setState({ openAddStudent: false, showBulkImportModal: false })
        if (this.tooltip) {
            this.tooltip.tooltipRef = null
            this.tooltip.hideTooltip()
        }
        ReactTooltip.hide()
    }

    bulkStudentImport = () => {
        this.setState({ showBulkImportModal: true })
    }

    hideBulkStudentImport = () => {
        this.setState({ showBulkImportModal: false })
        if (this.tooltip) {
            this.tooltip.tooltipRef = null
            this.tooltip.hideTooltip()
        }
        ReactTooltip.hide()
    }

    renderAddStudent() {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.closeAddStudentModal} size={"lg"}>
                <ModalBody>

                    <div className="row">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.closeAddStudentModal} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    <div className="header-text text-center">
                        <span>{this.state.mode == "CREATE" ? "ADD A STUDENT" : "EDIT STUDENT"}</span>
                    </div>
                    <div className="px-4">
                        <AddStudentComponent ref={el => this.addStudentRef = el} showSetupSection={this.showSetupSection} mode={this.state.mode} selectedUser={this.state.selectedUser} size={'lg'} onSave={this.onSaveStudent} onClose={this.closeAddStudentModal} />
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    showExcelFormat = () => {
        const link = document.createElement('a');
        link.href = Constants.STUDENT_EXCEL_FORMAT_3
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    showToaster(type, message) {
        this.setState(
            {
                showToaster: true,
                toasterMessage: message,
                toasterType: type
            },
            () => {
                setTimeout(() => {
                    this.hideToaster()
                }, 3000)
            }
        )
    }

    hideToaster() {
        this.setState({
            showToaster: false
        })
    }

    renderSetupSection() {
        return (
            <Modal className="cw-custom-modal modal-setup-section" isOpen={true} toggle={this.hideSetupClass} size={"lg"}>
                <ModalBody >

                    <div className="row">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.hideSetupClass} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    {/* <div className="header-text text-center">
                        <span>SETUP SECTIONS FOR {this.state.selectedClass.toUpperCase()}</span>
                    </div> */}
                    <div className="px-4">
                        <SetupSection from="teachers" onClose={this.hideSetupClass} class={this.state.selectedClass} board={this.state.selectedBoard} />
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    render() {

        if (this.state.showAssignSection) {
            return <AssignSection from={this.state.from} back={this.handleback} selectedClass={this.selectedClass} />
        }

        return (
            <>
                {
                    this.state.isLoading && <div ><Loading> </Loading></div>
                }

                <div className='student-list'>
                    <div className='header-container'>
                        <div className='row' onMouseEnter={ReactTooltip.rebuild}>
                            <div className='col-3'>
                                <span className='screen-title'>Students</span>
                            </div>
                            <div className='col-9 text-right'>
                                <span>
                                    {
                                        this.accessRights[AccessRights.INVITE_STUDENT] ?
                                            <span>
                                                <button className='cw-btn-md-v1 d-inline-block cw-btn-secondary mr-2' onClick={() => this.showInviteStudents()} data-tip={"Invite Students"}>
                                                    INVITE STUDENTS VIA WHATSAPP
                                                </button>
                                            </span> : ""
                                    }
                                    {
                                        this.accessRights[AccessRights.ADD_STUDENT] ?
                                            <span>
                                                <button className='cw-btn-md d-inline-block cw-btn-primary mr-2' onClick={() => this.onClickAddStudent({}, 'CREATE')} data-tip={"Add New Student"}>
                                                    ADD NEW STUDENT
                                                </button>
                                            </span> : ""
                                    }
                                    {
                                        this.accessRights[AccessRights.BULK_UPLOAD_STUDENT] ?
                                            <span>
                                                <button className='cw-btn-md cw-btn-success ' onClick={() => this.bulkStudentImport()} data-tip={"Bulk Upload Students"}>
                                                    BULK EXCEL UPLOAD
                                                </button>
                                                <div>
                                                    <span className='check-text' onClick={this.showExcelFormat}>
                                                        <img
                                                            className='export-xls'
                                                            src={getImageSource(ImageConstants.XLS_BLUE)}
                                                        />
                                                        Check Format Here
                                                    </span>
                                                </div>
                                            </span>
                                            : ""
                                    }
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className='mt-5'>
                        <Filter ref={el => this.filterRef = el} delegate={this} onAssignSection={this.onClickAssign} />
                    </div>
                    {
                        this.state.showList ?
                            <div>
                                {/* {this.user?.schoolInfo?.schoolTempId ?  */}
                                {/* <IMDStudentList students={this.state.studentList} onRefreshList={this.onRefreshList} /> : */}
                                <StudentList ref={el => this.studentListRef = el} showSetupSection={this.showSetupSection} onRefreshList={this.onRefreshList} onPageSelected={this.onPageSelected} />
                                {/* } */}

                            </div>
                            : ""
                    }
                </div >
                {this.state.showInviteStudents && <InviteStudents onClose={this.hideInviteStudents} />}
                {this.state.openAddStudent && this.renderAddStudent()}
                {this.state.showSetupSection && this.renderSetupSection()}
                {this.state.showBulkImportModal && <StudentBulkImport mode={this.state.mode} size={'lg'} onSave={this.onSaveStudent} onClose={this.hideBulkStudentImport} type="CLASS_FROM_EXCEL" />}
                {this.state.showToaster ? (
                    <div className='custom-toaster-modal'>
                        <ToasterComponent message={this.state.toasterMessage} type={this.state.toasterType} position="bottom-center" />
                    </div>
                ) : (
                    ''
                )}
                <ReactTooltip ref={el => this.tooltip = el} multiline={true} place='bottom' type='dark' effect='solid' event="mouseover mouseenter" eventOff="mouseleave mouseout scroll mousewheel blur" />
            </>
        );
    }
}

export default Students;